import { useParams, useSearchParams } from 'react-router-dom'

import { Avatar, Box, Tabs } from '@factorialco/deprecated-design-system'
import {
  PerformanceProcessTargetPageDocument,
  PerformanceProcessTargetPageReporteesDocument,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import buildUrl from 'modules/core/lib/buildUrl'
import { isEnumValue } from 'modules/core/lib/utils/enums'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { PersonalResults } from 'modules/performance_process/components/review/show/PersonalResults'
import {
  TabsIdsEnum,
  TabsIdsEnumValues,
  buildTargetPageTabs,
} from 'modules/performance_process/lib/buildTargetPageTabs'

import { TeamInfo } from './teamInfo/TeamInfo'

const ReviewTargetPage = () => {
  const { targetId: reviewProcessTargetId, reviewId } = useParams()

  const { data, loading, error } = useQuery(PerformanceProcessTargetPageDocument, {
    variables: {
      reviewProcessTargetId: reviewProcessTargetId ?? '',
    },
  })

  const targetAccess = data?.performance.reviewProcessTarget?.access

  const { data: reporteesData } = useQuery(PerformanceProcessTargetPageReporteesDocument, {
    variables: {
      reviewProcessId: String(reviewId),
      targetEmployeeId: String(targetAccess?.employee?.id),
    },
    skip: !reviewId || !targetAccess?.employee?.id,
  })

  const hasReportees = !!reporteesData?.performance.reviewProcessTargetsConnection.totalCount

  const tabs = buildTargetPageTabs()
  const [searchParams, setSearchParams] = useSearchParams()
  const isTeamTab = searchParams.get('team') == 'true'
  const isPersonalTab = !isTeamTab
  const currentTab: TabsIdsEnum = isTeamTab ? 'team' : 'personal'

  const switchTabs = (tabId: TabsIdsEnum) => {
    if (tabId == 'team') {
      setSearchParams({ team: 'true' })
    } else {
      setSearchParams({})
    }
  }

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      showHeader={false}
      header={{
        illustrationComponent: (
          <Avatar
            size="s32"
            url={buildUrl(targetAccess?.avatar)}
            label={targetAccess?.fullName ?? ''}
          />
        ),
      }}
    >
      <Box gap="s32" flexGrow>
        {hasReportees && (
          <Tabs
            key={'feedback-tabs'}
            currentId={tabs.find((tab) => tab.id == currentTab)?.id ?? ''}
            onTabClicked={(tabId) => isEnumValue(TabsIdsEnumValues, tabId) && switchTabs(tabId)}
            hasAdditionalPadding
            tabsAlign="flexStart"
          >
            {tabs.map((tab) => (
              <Tabs.Tab key={tab.id} id={tab.id} label={tab.label} />
            ))}
          </Tabs>
        )}
        {isPersonalTab && reviewId && reviewProcessTargetId && (
          <PersonalResults reviewProcessTargetId={reviewProcessTargetId} />
        )}
        {isTeamTab && reviewId && targetAccess && (
          <TeamInfo reviewId={String(reviewId)} targetAccess={targetAccess} />
        )}
      </Box>
    </ResponsivePage.Body>
  )
}

export default ReviewTargetPage
